<template>
  <div>
    <b-card no-body>
      <b-card-body>
        <b-card bg-variant="light">
          <b-form-row @keyup.enter="load">
            <lg-form-input v-model="form.numeroPedido" label="Número do Pedido:" description=" "
              cols="12" sm="4" />
            <lg-form-input v-model="form.apelido" label="Apelido:" description="" cols="12" sm="4" />
            <lg-form-date invalidFeedback=" " description=" " v-model="form.dataDe"
              label="De:" cols="6" sm="2" />
            <lg-form-date invalidFeedback=" " description=" " v-model="form.dataAte"
              label="Até:" cols="6" sm="2" />
            <lg-form-input v-model="form.numeroProduto" label="Número do Produto:"
              description=" " cols="12" sm="6" />
            <lg-form-input v-model="form.processo" label="Processo:" description=" " cols="12" sm="6" />
            <lg-form-input v-model="form.produto" label="Produto:" description=" " cols="12" sm="4" />
            <lg-form-const-select label="Status:" v-model="form.idStatus" cols="12" sm="4"
              :options="optionsFilterStatus" @change="load" />
            <b-col cols="12" sm="4" class="text-right">
              <b-button id="localizarCCP" class="ml-3 mr-2 my-2" size="sm" pill variant="primary" @click="load()">
                <b-icon icon="search" />
                <b-tooltip target="localizarCCP" title="Localizar" ></b-tooltip>
              </b-button>
              <b-button id="apagarCCP" class="ml-3 mr-2 my-2" size="sm" pill variant="primary" @click="clearForm">
                <b-icon icon="eraser" />
                <b-tooltip target="apagarCCP" title="Apagar" ></b-tooltip>

              </b-button>
            </b-col>
          </b-form-row>
          <b-table responsive class="mt-2" small :busy="this.busy" :items="this.records" :fields="this.tableFields"
            :hover="true" show-empty>
            <template #empty>
              <p>Nenhum registro encontrado</p>
            </template>
            <template #table-busy>
              <div class="text-center text-primary my-2">
                <b-spinner class="align-middle"></b-spinner>
              </div>
            </template>
            <template v-slot:cell(numeroPedido)="data">
              <b-link  class="" @click="showDetalhamento(data.item)">
                {{ data.item.numeroPedido }}
              </b-link>
            </template>
            <template v-slot:cell(data)="data">
              {{ formatDate(data.item.data) }}
            </template>
            <template v-slot:cell(situacao)="{ item }">
              <b-form-checkbox v-model="item.situacao" @change="alteraSituacao(item)" name="check-button" switch
                size="lg" :value="1" :unchecked-value="0" />
            </template>
          </b-table>
          <div class="row">
            <div class="h6 col-sm-6" style="display: flex; align-items: center;">Página {{ page }} de {{ totalPage }} -
              {{
                total
              }} registros</div>
            <div class="col-sm-6">
              <b-pagination v-model="page" :per-page="perPage" :total-rows="total" ></b-pagination>
            </div>
          </div>
        </b-card>
      </b-card-body>
    </b-card>
    <DetalhamentoPedido v-if="showModalDetalhamento" :prefix='updatedPrefix' @close="cancelar"
      :idPedido="idPedidoSelecionado" />
  </div>
</template>

<script>
import ResourceService from "@/core/api/ResourceService"
import LgFormConstSelect from "@/core/components/Form/LgFormConstSelect.vue"
import LgFormDate from "@/core/components/Form/LgFormDate.vue"
import LgFormInput from "@/core/components/Form/LgFormInput.vue"
import ConfirmMixin from "@/core/mixins/confirm"
import { FormResourceMixin, ListResourceMixin } from "@/core/mixins/resource"
import DetalhamentoPedido from "./DetalhamentoPedido.vue"

export default {
  components: {
    LgFormInput,
    LgFormConstSelect,
    LgFormDate,
    DetalhamentoPedido
  },
  props: {
    prefix: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      showModalDetalhamento: false,
      optionsFilterStatus: [
        { key: "filterSituacao", text: "Todos", value: undefined },
        { key: "filterSituacao", text: "Aguardando", value: 223 },
        { key: "filterSituacao", text: "Em análise", value: 222 },
        { key: "filterSituacao", text: "Finalizado", value: 224 },
      ],
      form: {
        produto: null,
        numero: null,
        numeroPedido: null,
        numeroProduto: null,
        apelido: null,
        processo: null,
        almoxarifado: null,
        idStatus: null,
        dataDe: null,
        dataAte: null,
      },
      pedidoSelecionado: null,
      idPedidoSelecionado: null
    }
  },
  mixins: [ListResourceMixin, FormResourceMixin, ConfirmMixin],
  beforeMount() {
    this.$service = new ResourceService(`/api/pedidosprodutocatalogo`);
    this.load();
  },

  watch: {
    page() {
      this.load()
    },
    'form.produto'() {
      if (this.form.produto === undefined || this.form.produto === '') {
        this.records = []
      }
    },
  },
  computed: {
    updatedPrefix() {
      return [...this.prefix]
    },
    title() {
      return this.updatedPrefix.join(" > ")
    },
    tableFields() {
      return [
        { key: "numeroPedido", label: "Pedido" },
        { key: "data", label: "Data" },
        { key: "justificativa", label: "Justificativa" },
        { key: "status.descricao", label: "Status" }
      ]
    },
  },
  methods: {
    formatDate(date) {
      if (!date) return null
      const [year, month, day] = date.split('T')[0].split('-')
      return `${day}/${month}/${year}`
    },
    async load() {
      this.busy = true
      await this.$loadResource({
        limit: this.perPage,
        page: this.page,
        params: this.form,
        isOrOperation: false,
      })
    },
    async alteraSituacao(item) {
      const { status } = await this.$service.alteraSituacao(item)
      if (status == 200) {
        this.$notify({ type: 'success', message: `Registro ${item.situacao ? "Ativado" : "Desativado"} com sucesso!` })
      } else {
        this.$notify({ type: 'danger', message: `Erro ao ${item.situacao ? "Ativar" : "Desativar"} o registro!` })
        item.situacao = !item.situacao
      }
    },
    clearForm() {
      this.form = {
        produto: null,
        numero: null,
        numeroPedido: null,
        numeroProduto: null,
        apelido: null,
        processo: null,
        almoxarifado: null,
        status: null,
        dataDe: null,
        dataAte: null,
      }
      this.load();
    },
    cancelar() {
      this.showModalDetalhamento = false
      this.pedidoSelecionado = null
      this.load()
    },
    showDetalhamento(pedido) {
      this.pedidoSelecionado = pedido
      this.idPedidoSelecionado = pedido.id
      this.showModalDetalhamento = true
    }
  }
}
</script>
